import { render, staticRenderFns } from "./ImportTicketBatch.vue?vue&type=template&id=72d867a8"
import script from "./ImportTicketBatch.vue?vue&type=script&lang=js"
export * from "./ImportTicketBatch.vue?vue&type=script&lang=js"
import style0 from "./ImportTicketBatch.vue?vue&type=style&index=0&id=72d867a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports